<template>
  <el-container style="width: 1200px;margin: 35px auto 0px auto;padding: 35px 20px 50px;flex-flow: row">
    <!--头像-->

    <!--侧边栏-->
    <!--<el-aside>-->
    <!--  <div style="background-color: #f8fafc">-->

    <!--    -->
    <!--    <hr style="margin: 0px 4px 10px 4px;background-color:#d9dde1;height: 1px;border: none;">-->
    <!--    左侧菜单-->
    <!--    <el-menu-->
    <!--            :default-active="activeIndex"-->
    <!--            router-->
    <!--            class="el-menu-vertical-demo">-->
    <!--      &lt;!&ndash;<el-menu-item index="/home/mine/info">&ndash;&gt;-->
    <!--      &lt;!&ndash;  <i class="el-icon-notebook-2"></i>&ndash;&gt;-->
    <!--      &lt;!&ndash;  <span slot="title">个人信息</span>&ndash;&gt;-->
    <!--      &lt;!&ndash;</el-menu-item>&ndash;&gt;-->
    <!--      <el-submenu index="/home/mine/course">-->
    <!--        <template slot="title">-->
    <!--          <i class="el-icon-menu"></i>-->
    <!--          <span>我的课程</span>-->
    <!--        </template>-->
    <!--        <el-menu-item index="/home/mine/course/All">全部课程</el-menu-item>-->
    <!--        <el-menu-item index="/home/mine/course/O">技术人员培训学习</el-menu-item>-->
    <!--        <el-menu-item index="/home/mine/course/C">技术人员宣贯学习</el-menu-item>-->
    <!--      </el-submenu>-->
    <!--      <el-menu-item index="/home/mine/course">-->
    <!--        <i class="el-icon-menu"></i>-->
    <!--        <span slot="title">我的课程</span>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="/home/myOrder">-->
    <!--        <i class="el-icon-s-order"></i>-->
    <!--        <span slot="title">我的订单</span>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="/home/mine/bindingTel">-->
    <!--        <i class="el-icon-mobile-phone"></i>-->
    <!--        <span slot="title">绑定手机</span>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="/home/mine/certification">-->
    <!--        <i class="el-icon-postcard"></i>-->
    <!--        <span slot="title">实名认证</span>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="/home/mine/credentials">-->
    <!--        <i class="el-icon-tickets"></i>-->
    <!--        <span slot="title">我的证书</span>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="/home/mine/updatePassword">-->
    <!--        <i class="el-icon-unlock"></i>-->
    <!--        <span slot="title">修改密码</span>-->
    <!--      </el-menu-item>-->
    <!--      <el-menu-item index="/home/help">-->
    <!--        <i class="el-icon-question"></i>-->
    <!--        <span slot="title">帮助中心</span>-->
    <!--      </el-menu-item>-->
    <!--    </el-menu>-->
    <!--    -->
    <!--  </div>-->
    <!--</el-aside>-->
    <!--更换头像对话框-->
<!--    <el-dialog title="更换头像"-->
<!--               :visible.sync="dialogFormVisible"-->
<!--               width="500px"-->
<!--               :lock-scroll="false"-->
<!--               :close-on-click-modal="false"-->
<!--               :destroy-on-close="true"-->
<!--               :before-close="cleanFile">-->
<!--      <div style="display: flex;justify-content: center">-->
<!--        <img :src="newCircleUrl"-->
<!--             style="object-fit: cover;border-radius: 50%;border: 4px solid #d9dde1;width: 200px;height: 200px"-->
<!--             :onerror="failCircleUrl">-->
<!--      </div>-->
<!--      <input ref="imgUpload" @change="fileChange($event)" style="display: none" type="file" accept="image/*"/>-->
<!--      <div slot="footer" style="text-align: center">-->
<!--        <el-button @click="openFileExplorer">上传头像</el-button>-->
<!--        <el-button type="primary" @click="uploadImg" :disabled="allowUpload">确认更换</el-button>-->
<!--      </div>-->
<!--    </el-dialog>-->
    <!--内容区-->
    <div class="main-content">
<!--      <div  @mouseenter="showTip = true" @mouseleave="showTip = false" class="avatar-border" v-else>-->
<!--&lt;!&ndash;        <a @click="dialogFormVisible = true">&ndash;&gt;-->
<!--          <img :src="circleUrl" width="92" height="92" style="object-fit: cover" :onerror="failCircleUrl">-->
<!--&lt;!&ndash;          <div v-show="showTip" class="avatar-tip">更换头像</div>&ndash;&gt;-->
<!--&lt;!&ndash;        </a>&ndash;&gt;-->
<!--      </div>-->
      <router-view></router-view>
    </div>
  </el-container>

</template>

<script>
  export default {
    name: "Mine",
    data(){
      return {
        defaultCircleUrl: require('@/assets/img/defaultAvatar.png'),
        failCircleUrl: 'this.src="' + require('@/assets/img/failAvatar.png') + '"' + ';this.onerror=null;',
        showTip: false,
        userName: '',
        userId: '',

        activeIndex: '',
        circleUrl: '',
        // dialogFormVisible: false,
        // newCircleUrl: '',

        imgFile: null,
        // allowUpload: true,
      }
    },
    watch: {
      $route: function () {
        this.changeIndex();
      }
    },
    methods: {
      changeIndex(){
        const path = this.$route.path;
        if(path.includes('info')){
          this.activeIndex = '/home/mine/info';
        }else if(path.includes('All')){
          this.activeIndex = '/home/mine/course/All';
        }else if(path.includes('O')){
          this.activeIndex = '/home/mine/course/O';
        }else if(path.includes('C')){
          this.activeIndex = '/home/mine/course/C';
        }else if(path.includes('certification')) {
          this.activeIndex = '/home/mine/certification';
        }else if(path.includes('credentials')){
          this.activeIndex = '/home/mine/credentials';
        }else if(path.includes('bindingTel')){
          this.activeIndex = '/home/mine/bindingTel';
        }else if(path.includes('updatePassword')){
          this.activeIndex = '/home/mine/updatePassword';
        }else {
          this.activeIndex = '';
        }
      },
      // openFileExplorer(){
      //   // this.$refs.imgUpload.value = '';
      //   // dispatchEvent兼容ie
      //   let event = document.createEvent("MouseEvent");
      //   event.initEvent("click", false, true);
      //   this.$refs.imgUpload.dispatchEvent(event)
      // },
      // fileChange(e){
      //   if (e.target.files[0]) {
      //     this.newCircleUrl = this.getFilePath(e.target.files[0]);
      //     this.imgFile = e.target.files[0];
      //     this.allowUpload = false;
      //   }
      // },
      getFilePath(file){
        let path = '';
        if (window.createObjectURL != undefined) {
          // basic
          path = window.createObjectURL(file);
        } else if (window.webkitURL != undefined) {
          // webkit or chrome
          path = window.webkitURL.createObjectURL(file);
        } else if (window.URL != undefined) {
          // mozilla(firefox)
          path = window.URL.createObjectURL(file);
        }
        return path;
      },
      // async uploadImg(){
      //   let param = new FormData(); //创建form对象
      //   param.append('file',this.imgFile);
      //   let config = {headers:{'Content-Type':'multipart/form-data'}};
      //   const {content} = await this.$http.post("/file/web/uploadOss",param,config);
      //   const {success} = await this.$http.post("/system/web/user/update",{headImg:content});
      //   if (success){
      //     this.circleUrl = content;
      //     const userInfo = this.$store.state.userInfo;
      //     userInfo.headImg = content;
      //     LocalStorage.setTime(LOCAL_KEY_USER_INFO,userInfo);
      //     this.$store.commit('refreshUser');
      //     this.$message.success("头像上传成功");
      //     this.dialogFormVisible = false;
      //     this.allowUpload = true;
      //   }else {
      //     this.$message.error("头像上传失败")
      //   }
      // },
      cleanFile(){
        this.$refs.imgUpload.value = '';
        this.dialogFormVisible = false;
      },
    },
    created() {
      const userInfo = this.$store.state.userInfo;
      if (userInfo){
        this.userName = userInfo.name;
        this.userId = userInfo.id;
        this.circleUrl = !userInfo.headImg ? this.defaultCircleUrl : userInfo.headImg;
        // this.newCircleUrl = this.circleUrl;
      }
    },
    mounted() {
      this.changeIndex();
    },
  }
</script>

<style scoped>
  .el-aside{
    overflow: inherit;
    width: 200px !important;
  }

  /*.avatar-border{*/
  /*  position: absolute ;*/
  /*  left: 50%;*/
  /*  transform: translateX(-50%);*/
  /*  top: -64px;*/
  /*  height: 92px;*/
  /*  width: 92px;*/
  /*  overflow:hidden;*/
  /*  border-radius: 50px;*/
  /*  border: 4px solid #d9dde1;*/
  /*  text-align: center;*/
  /*}*/
  .main-content {
    position: relative;
    width: 930px;
    margin: 20px 0 auto;
  }
  .avatar-tip{
    position:absolute;
    cursor: pointer;
    height: 30px;
    width: 92px;
    bottom: 0px;
    left: 0px;
    line-height: 26px;
    font-size: 12px;
    color: #fff;
    background-color: #1c1f21;
  }

  .el-menu{
    background-color: #f8fafc;
    border-right: none;
  }
  .el-menu-item{
    background-color: #f8fafc;
  }
  .el-submenu >>> .el-submenu__title{
    background-color: #f8fafc !important;
  }
  .el-menu-item.is-active{
    font-weight: 800;
    color: #fff;
    background-color: #409EFF;
  }

  .el-dialog__wrapper{
    overflow: inherit;
  }
  .el-dialog__wrapper >>> .el-dialog{
    border-radius: 10px !important;
  }

  .el-dialog__wrapper >>> .el-dialog__title{
    font-size: 16px !important;
    font-weight: bold !important;
    color: #1c1f21 !important;
  }

</style>
